import { render, staticRenderFns } from "./ToolIcon.vue?vue&type=template&id=38b3d9cd&"
import script from "./ToolIcon.vue?vue&type=script&lang=js&"
export * from "./ToolIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports